import { createFileRoute } from '@tanstack/react-router';
import { JobDetailRoute } from '@/pages/admin/system-monitor/job-detail-route';

/** Deep link al dettaglio del job: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/runs/_layout/$id'
)({
  component: JobDetailRouteComponent,
});

function JobDetailRouteComponent() {
  const { id } = Route.useParams();
  const search = Route.useSearch();

  return <JobDetailRoute jobId={id} search={search} />;
}
